
module.classy.controller({
    name: 'contactInfoController',
    inject: ['$scope', 'participant', 'ModelConfig'],
    data: {participant: 'participant'},
    init: function() {
        var self = this;
        this.ModelConfig.getUsStates(true).then(function(states) {
            self.$.states = states;
        })
    },
});
